import type { Region } from "@sg-protect/runtime-config";
import type { ShellTranslationKey } from "../i18n/i18next.ts";

/** English names of the regions, tracked in analytics whatever the display language. */
export const REGION_LABELS: Record<Region, string> = {
    na: "North America",
    eu: "Europe"
};

export const REGION_LABEL_KEYS = {
    na: "Regions.na",
    eu: "Regions.eu"
} as const satisfies Record<Region, ShellTranslationKey>;
